export default "__VITE_ASSET__c32478f9__"